<template>
    <div id="loyalty-level">
        <!--=====================================-->
        <!--=        How It Works Area Start     =-->
        <!--=====================================-->
        <section class="section mb--100" data-sal="slide-up" data-sal-duration="800">
            <div class="container">
                <div class="section-heading heading-left">
                    <span class="subtitle primary">Unete al Programa</span>
                    <div class="row">
                        <div class="col-lg-12 mb--30">
                            <h1 class="font-weight-100">
                                Sube tu <span class="bold">nivel de compromiso</span>
                                y descubre cuánto puedes <span class="bold">ahorrar.</span>
                            </h1>
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            <!-- TABLA TEST -->
                            <div class="table-responsive">
                                <table class="table rg-table">
                                    <thead>
                                        <tr>
                                            <th v-for="(column, index) in columns" scope="col"
                                                :class="column.bold ? 'bold' : 'normal'">{{ column.title }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(tr, index) in data">
                                            <td>{{ tr.level }}</td>
                                            <td>{{ tr.goals }}</td>
                                            <td>{{ tr.commission }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div>
                                    <!-- <small><i>* datos contemplados al cierre de mes.</i></small> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-7 col-lg-7">
                            <!-- TABLA TEST -->
                            <div class="table-responsive">
                                <table class="table rg-table">
                                    <thead>
                                        <tr>
                                            <th v-for="(column, index) in columns1" scope="col"
                                                :class="column.bold ? 'bold' : 'normal'">{{ column.title }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(tr, index) in data1">
                                            <td>{{ tr.interest }}</td>
                                            <td>{{ tr.commission }}</td>
                                            <td>{{ tr.tax }}</td>
                                            <td>{{ tr.net }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div>
                                    <!-- <small><i>* datos contemplados al cierre de mes.</i></small> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--=====================================-->
        <!--=        Blog Area Start       	    =-->
        <!--=====================================-->
        <section class="section mb--100" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
            <div class="container">
                <div class="row row-40">
                    <div class="col-lg-12">
                        <h6 class="bold mb-0">Tu nivel de compromiso en la Red.</h6>
                        <p class="body-font1 mb-4">
                            En la barra superior de tu cuenta de inversionista podrás descubrir cuántos compromisos 
                            tienes activos y en qué nivel vas conforme al color de tu avatar.
                            ¿Qué nivel de compromiso tendrás?
                        </p>
                    </div>
                    <div class="col-12">
                        <img src="https://cdn.redgirasol.com/nuevo_portal/banners/programa-compromiso/banner-example.png" alt="Ejemplo de perfil de instalador de RedGirasol.">
                    </div>
                    <!-- <div class="col-sm-12 col-md-8 col-lg-8">
                        <div class="single-blog">
                            <div class="blog-author shadow-box">
                                <div class="author">
                                    <div class="row">
                                        <div class="col-sm-2 col-md-2 icon-center">
                                            <div class="author-thumb">
                                                <img :src="imgTest" alt="Blog Author">
                                            </div>
                                        </div>
                                        <div class="col-sm-2 col-md-2 icon-center">
                                            <div class="author-thumb">
                                                <img :src="imgTest" alt="Blog Author">
                                            </div>
                                        </div>
                                        <div class="col-sm-2 col-md-2 icon-center">
                                            <div class="author-thumb">
                                                <img :src="imgTest" alt="Blog Author">
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 align-self-center">
                                            <div class="info text-end">
                                                <h4 class="title bold mb-0">Jane Doe</h4>
                                                <p class="body-font1 font-25px mb-0">20/12/23, 6:26p.m.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="author-thumb icon-center">
                                        <img :src="imgTest" alt="Blog Author">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4 mb-0">
                        <div class="single-blog">
                            <div class="blog-author">
                                <div class="author">
                                    <div class="row">
                                        <div class="col-4 icon-center">
                                            <div class="author-thumb">
                                                <img :src="imgTest" alt="Blog Author">
                                            </div>
                                        </div>
                                        <div class="col-4 icon-center">
                                            <div class="author-thumb">
                                                <img :src="imgTest" alt="Blog Author">
                                            </div>
                                        </div>
                                        <div class="col-4 icon-center">
                                            <div class="author-thumb">
                                                <img :src="imgTest" alt="Blog Author">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </section>
    </div>
</template>

<script>
const columns = [
    { title: "Nivel", bold: true },
    { title: "Compromisos", bold: true },
    { title: "Comisión", bold: true }
];

const columns1 = [
    { title: "Intereses pagados", bold: true },
    { title: "Comisión", bold: true },
    { title: "IVA", bold: true },
    { title: "Intereses netos", bold: true }
];

const data = [
    { level: "Inicial", goals: "0", commission: "9%" },
    { level: "Medio",   goals: "1", commission: "6%" },
    { level: "Alto",    goals: "2", commission: "3%" },
    { level: "Total",   goals: "3", commission: "0%" },
];

const data1 = [
    { interest: "$100.00", commission: "$9.00", tax: "$1.44", net: "$89.56" },
    { interest: "$100.00", commission: "$6.00", tax: "$0.96", net: "$93.04" },
    { interest: "$100.00", commission: "$3.00", tax: "$0.48", net: "$96.52" },
    { interest: "$100.00", commission: "$0.00", tax: "$0.00", net: "$100.00" },
]

export default {
    data: () => ({
        columns: columns,
        columns1: columns1,
        data: data,
        data1: data1,
        imgTest: "https://cdn.redgirasol.com/nuevo_portal/icons/icon-water.png"
    }),
    props: {
        source: String
    }
}
</script>

<style>

.info {
    padding-right: 2.5rem;
}

.blog-author {
    border-radius: 15px;
    padding: 2rem;
    background-color: var(--color-white);
}

.font-25px {
    font-size: 25px;
}

.icon-center {
    align-self: center;
    text-align: center;
}

.align-self-center {
    align-self: center;
}

</style>